import React from 'react'

const SvgDoc2 = props => (
  <svg fill='none' width={40} height={36} viewBox='0 0 40 36' {...props}>
    <defs>
      <linearGradient x1={0.5} y1={0} x2={0.5} y2={1} id='doc2_svg__a'>
        <stop offset='0%' stopColor='#FD8556' />
        <stop offset='100%' stopColor='#FD5C1E' />
      </linearGradient>
      <linearGradient x1={0.448} y1={0} x2={0.452} y2={1} id='doc2_svg__c'>
        <stop offset='0%' stopColor='#FF9E7A' />
        <stop offset='100%' stopColor='#FFA684' />
      </linearGradient>
      <filter
        id='doc2_svg__b'
        filterUnits='objectBoundingBox'
        colorInterpolationFilters='sRGB'
        x={0}
        y={0}
        width={40}
        height={28}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur in='BackgroundImage' stdDeviation={3.03} />
        <feComposite in2='SourceAlpha' operator='in' result='effect1_foregroundBlur' />
        <feBlend in='SourceGraphic' in2='effect1_foregroundBlur' result='shape' />
      </filter>
    </defs>
    <path
      d='M14.891 13h8.477c1.886 0 2.711 1.427 3.532 3.594l4.944 15.093C32.644 34.218 30.2 36 28.312 36h-17.66c-1.886 0-4.21-1.96-3.531-4.313l4.945-15.093c.839-2.03.939-3.594 2.825-3.594z'
      fill='url(#doc2_svg__a)'
    />
    <g filter='url(#doc2_svg__b)'>
      <rect width={40} height={28} rx={0} fill='#F8B399' fillOpacity={0.6} />
      <rect x={0.5} y={0.5} width={39} height={27} rx={0} stroke='url(#doc2_svg__c)' />
    </g>
    <path
      d='M22.569 22.266l9.485-9.177-2.108-2.178-7.5 7.258-7.749-6.648-8.746 8.385 2.098 2.188 6.761-6.484 7.759 6.656z'
      fillRule='evenodd'
      fill='#FFF'
    />
    <g>
      <path d='M32.81 9.62l-.564 6.31-5.62-5.24 6.184-1.07z' fill='#FFF' />
    </g>
  </svg>
)

export default SvgDoc2
